import { css } from '@emotion/core';

export const customTableStyle = {
  root: css`
    margin: 12px;
  `,
  button: css`
    padding: 4px !important;
  `,
  container: css`
    max-height: 500px;
  `,
  iconContainer: css`
    display: flex;
  `,
  spinnerCell: css`
    display: flex !important;
    justify-content: center;
    width: 100%;
  `,
  spinner: css`
    margin: 24px;
  `,
};
